import Check from "lucide-react/dist/esm/icons/check";
import Bot from "lucide-react/dist/esm/icons/bot";
import LogOut from "lucide-react/dist/esm/icons/log-out";
import Users from "lucide-react/dist/esm/icons/users";
import type { RoomView } from "../../game";
import { Countdown } from "./countdown";

interface WaitingRoomProps {
  room: RoomView;
  onReady: () => void;
  onLeave: () => void;
}

export function WaitingRoom({ room, onReady, onLeave }: WaitingRoomProps) {
  const self = room.players.find((player) => player.id === room.selfId);
  const rival = room.players.find((player) => player.id !== room.selfId);
  const seriesActive = (self?.wins ?? 0) + (rival?.wins ?? 0) > 0;
  const botMatch = room.settings.mode === "bot";

  return (
    <main className="waiting-shell">
      <header className="room-header">
        <span className="wordmark wordmark--small">CHIN!</span>
        <button className="icon-button" type="button" onClick={onLeave} aria-label="Salir de la mesa">
          <LogOut aria-hidden="true" size={21} />
        </button>
      </header>

      <section className="waiting-content">
        <p className="eyebrow">
          {botMatch
            ? <Bot aria-hidden="true" size={15} />
            : <Users aria-hidden="true" size={15} />} Mesa lista
          {room.settings.decks === 2 ? <span className="deck-badge">2 mazos</span> : null}
          {seriesActive ? <span className="deck-badge">Serie {self?.wins ?? 0}–{rival?.wins ?? 0}</span> : null}
        </p>
        <h1>{botMatch ? "La máquina está lista" : rival ? "Los dos están dentro" : "Tu rival dejó la mesa"}</h1>
        <p>{botMatch
          ? "Arranca la cuenta regresiva. Esta partida no afecta el ranking."
          : rival
            ? "Cuando ambos estén listos, arrancamos la cuenta regresiva."
            : "Volvé al inicio y tocá Jugar ya para buscar otro rival."}</p>

        <div className="player-seats">
          {[self, rival].map((player, index) => (
            <div className={`player-seat ${player?.ready ? "is-ready" : ""}`} key={player?.id ?? `empty-${index}`}>
              <span className="player-avatar">{player?.name.charAt(0).toUpperCase() ?? "?"}</span>
              <span>
                <strong>{player?.name ?? "Nadie"}</strong>
                <small>{player ? player.id === room.selfId ? "Vos" : "Rival" : "Lugar libre"}</small>
              </span>
              {player?.ready ? <Check className="ready-check" aria-label="Listo" size={21} /> : <i className="seat-status" aria-hidden="true" />}
            </div>
          ))}
        </div>

        <div className="waiting-rules" aria-label="Resumen de reglas">
          <span><b>1</b> Jugá ±1</span>
          <span><b>2</b> Vacía tu mazo</span>
          <span><b>3</b> Cantá CHIN primero</span>
        </div>

        {rival ? (
          <button className="primary-button ready-button" type="button" onClick={onReady} disabled={self?.ready || room.phase === "countdown"}>
            {self?.ready ? "Esperando al rival…" : "Estoy listo"}
          </button>
        ) : (
          <button className="primary-button ready-button" type="button" onClick={onLeave}>
            Volver al inicio
          </button>
        )}
      </section>

      {room.phase === "countdown" && room.countdownEndsAt ? <Countdown endsAt={room.countdownEndsAt} /> : null}
    </main>
  );
}
